import axios from "axios";
import { authWithRefresh } from "../authServices/auth.header";

const API_URL = process.env.VUE_APP_ROOT_API;
class AuthService {
  async login(user) {
    return await axios
      .post(API_URL + "pbx-user/login", {
        data: btoa(
          JSON.stringify({
            email: user.email,
            password: user.password,
          })
        ),
      })
      .then((response) => {
        if (response.data.access_token) {
          sessionStorage.setItem("user", JSON.stringify(response.data));
          // localStorage.setItem("rfToken", response.data.refresh_token);
          let newTime = new Date().getTime();
          localStorage.setItem("LoginTime", newTime);
          // if (
          //   ["pbx_admin_staff", "super_admin"].includes(
          //     response?.data?.user?.user_type
          //   )
          // );
          // {
          //   localStorage.setItem("user", JSON.stringify(response.data));
          // }
        }
        return response.data;
      });
  }
  // FETCH NEW ACCESS TOKEN
  async newAccessToken(user_uuid) {
    return await axios
      .post(
        API_URL + "pbx-user/access-token",
        {
          data: btoa(JSON.stringify({ user_uuid: user_uuid })),
        },
        { headers: authWithRefresh() }
      )
      .then((response) => {
        if (response.data.access_token) {
          // localStorage.setItem("rfToken", response.data.refresh_token);
          sessionStorage.setItem("user", JSON.stringify(response.data));
          let newTime = new Date().getTime();
          localStorage.setItem("LoginTime", newTime);
        }
        return response.data;
      });
  }
  async loginWithOTP(user) {
    const { mail, otp } = user;
    return await axios
      .post(API_URL + "pbx-user/login", {
        data: btoa(JSON.stringify({ email: mail, otp_number: otp })),
      })
      .then((response) => {
        if (response.data.status) {
          let newTime = new Date().getTime();
          localStorage.setItem("LoginTime", newTime);
          if (
            response.data.access_token != null &&
            response.data.access_token != undefined &&
            response.data.message == "Login successful"
          ) {
            sessionStorage.setItem("user", JSON.stringify(response.data));
            // if (
            //   ["pbx_admin_staff", "super_admin"].includes(
            //     response?.data?.user?.user_type
            //   )
            // );
            // {
            //   localStorage.setItem("user", JSON.stringify(response.data));
            // }
          }
        }
        return response.data;
      })
      .catch((error) => {
        return error;
      });
  }
  logout() {
    sessionStorage.clear();
    sessionStorage.removeItem("user");
    sessionStorage.removeItem("hotel");
    localStorage.clear();
    localStorage.removeItem("user");
    localStorage.removeItem("hotel");
  }
}

export default new AuthService();
